import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const PublicLayout = () => (
  <SmoothScroll>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <FloatingButtons />
  </SmoothScroll>
);

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/servicos/:slug" element={<ServicePage />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
